import { createSlice } from "@reduxjs/toolkit";

import { initAssets } from "./thunks/init";
import * as thunks from "./thunks/thunks";
import { extraReducers } from "./thunks/extraReducers";

export const assetsSlice = createSlice({
  name: "assets",
  initialState: {
    init: {
      status: "idle",
    },
    filters: {},
    assets: [],
    count: 0,
  },
  reducers: {
    // Keep latest filters in Redux so they survive tab/route remounts
    setFilters: (state, action) => {
      state.filters = action.payload || {};
    },
  },
  extraReducers: {
    ...extraReducers,
  },
});

export const { setFilters } = assetsSlice.actions;

export { initAssets, thunks };

export default assetsSlice.reducer;
